export class LoginRequest {
  constructor(private username?: string | null, private password?: string | null) {
  }
}
